import React from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';

import NoResults from '../NoResults/NoResults';

import ProductAdvancedSearchLinks from './ProductAdvancedSearchLinks';

type Props = {
  searchTerm: string;
} & InjectedIntlProps;

const EmptyState = ({ searchTerm, intl }: Props) => {
  const title = intl.formatMessage(messages.noResultsTitle);

  return (
    <React.Fragment>
      <NoResults title={title} />
      <ProductAdvancedSearchLinks searchTerm={searchTerm} hasResults={false} />
    </React.Fragment>
  );
};

export default injectIntl(EmptyState);

const messages = defineMessages({
  noResultsTitle: {
    defaultMessage: "We couldn't find any recent work matching your search",
    description: 'title shown when searching for a term on your work have no results',
    id: 'uchi.noResultsTitle',
  },
});
